import React, { useEffect, useState } from 'react';
import { Row, Col } from 'reactstrap';
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";


const Footer = (props) => {

    const { t } = useTranslation();

    const [data, setData] = useState(null);
    useEffect(() => {
        setData(props?.dataCategoryList);
    }, [props]);


    return (
        <React.Fragment>
            <hr style={{
                color: '#2e4053',
                backgroundColor: '#2e4053',
                height: .5,
                borderColor: '#2e4053',
                paddingBottom: '5px'
            }} />

            <Row className='mt-3'>
                <Col className='col-md-12'>
                    {t('footer.copyright.product-name')} © Copyright {new Date()?.getFullYear()} {t('footer.copyright.company-name')}
                    {' '}
                    {t('footer.copyright.all-rights-reserved')}
                </Col>
            </Row>
        </React.Fragment >
    )
};

export default Footer;